export default "__VITE_ASSET__DLWjMkLc__"